import React, { useEffect, useState, createRef } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import Switch from '@material-ui/core/Switch'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed'
import SettingsIcon from '@material-ui/icons/Settings'
import {
  updateZoomCourseId,
  loadZoomEventsData,
  updateSelectedZoomEvents,
  updateZoomSchedulers
} from '../../actions'

import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'

import Grid from '@material-ui/core/Grid'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import BrowserStore from 'store'

import LinearProgress from '@material-ui/core/LinearProgress'

import {
  updateZoomOwner,
  getMySchedulers,
  updateMergeEvents
} from '../../services/saga'
import Alert from '@material-ui/lab/Alert'

import Tab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core/styles'
import MaterialTable from 'material-table'

import CourseTable from './CourseTable'

import Badge from '@material-ui/core/Badge'
import Chip from '@material-ui/core/Chip'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative'
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1
    },

    theme: {
      background: '#4caf500d'
    },

    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary
    },

    pullRight: {
      textAlign: 'right'
    },

    pullLeft: {
      textAlign: 'left'
    },

    chip: {
      margin: theme.spacing(0.5)
    },

    chipMerge: {
      margin: theme.spacing(0.5),
      background: '#fff'
    }
  })
)

const AntSwitch = withStyles((theme) => ({
  listRoot: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: '#000',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  },

  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex'
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
      }
    }
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none'
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white
  },
  checked: {}
}))(Switch)

const Transition = React.forwardRef(function Transition(
  props: { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  )
}

function createData(name, downloadLink) {
  return { name, downloadLink }
}

const csvTemplates = [
  createData('Group Enrollment Csv', 'Group-User-Enrollment-Template.csv')
]

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff'
    }
  },
  thumb: {
    width: 24,
    height: 24
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  )
})

function FullScreenDialog(props) {
  const classes = useStyles()

  const {
    fullPageModel,
    setFullPageModel,
    courseId,
    updateCourseId,
    updateZoomEvents,
    selectedEventIds,
    onUpdateSelected,
    onResponseSchedulers,
    schedulersList,
    courseDetails,
    zoomEvents
  } = props

  const browserData = BrowserStore.get('inseadCanvasAdmin')

  const tableRef = React.useRef(null)

  const [refreshTable, setRefreshTable] = useState(false)

  const [title, setTitle] = useState(`${courseId} Course Calendar Events`)
  const [subTitle, setSubTitle] = useState('NEW')
  const [openPublishDialog, setOpenPublishDialog] = useState(false)
  const [openMergeDialog, setOpenMergeDialog] = useState(false)

  const [zoomHost, setZoomHost] = useState('')
  const [zoomCoHostValue, setZoomCoHostValue] = useState('')
  const [zoomCoHost, setZoomCoHost] = useState([])
  const [zoomCoHostError, setZoomCoHostError] = useState(false)

  const [extendedSchedularList, setExtendedSchedularList] = useState([])

  const [errors, setErrors] = useState('')
  const [mergeErrors, setMergeErrors] = useState('')
  const [mergeParentEvent, setMergeParentEvent] = useState(null)

  // Radio switches
  const [owner, setOwner] = useState(true)
  const [visibility, setVisibility] = useState(false)

  const schedulersConfig = {
    admin: {
      name: 'LMS Admin',
      email: 'svc.lms@insead.edu'
    }
  }

  const [scheduler, setScheduler] = React.useState(schedulersConfig.admin)

  // 1 = NEW PUBLISH
  // 2 = Publish started
  // 3 Success
  const [publishProgress, setPublishProgress] = useState(1)
  // 1 = NEW PUBLISH
  // 2 = merge started
  // 3 Success
  const [mergeProgress, setMergeProgress] = useState(1)

  //onOpen Publish Dialog
  useEffect(() => {
    setOwner(true)
    setVisibility(false)
    setScheduler(schedulersConfig.admin)

    let selectedOwners = selectedEventIds.data.map((item) =>
      item.zoom_owner != undefined ? item.zoom_owner : 0
    )
    let selectedVisibility = selectedEventIds.data.map((item) =>
      item.zoom_visibility != undefined ? item.zoom_visibility : 0
    )

    let uniqOwners = [...new Set(selectedOwners)]
    let uniqVisibility = [...new Set(selectedVisibility)]

    let selectCoHost = selectedEventIds.data.map((item) =>
      item.zoom_alternative_host !== undefined ? item.zoom_alternative_host : ''
    )[0]

    console.log(
      uniqOwners.length,
      uniqVisibility.length,
      selectedEventIds,
      selectCoHost
    )

    //extendedSchedularList([...schedulersList, ]);

    setScheduler(schedulersConfig.admin)

    if (uniqOwners.length === 1) {
      if (uniqOwners[0] !== 0) {
        let selectFromList = schedulersList?.filter(
          (data) => data.email === uniqOwners[0]
        )

        console.log('uniqOwners', uniqOwners[0])
        if(selectFromList) {
          setScheduler(selectFromList[0])
        }
        setOwner(true)

        if (selectCoHost !== '' && openPublishDialog === true) {
          setZoomCoHost(selectCoHost.split(','))
        }
      }
    }

    if (uniqVisibility.length === 1) {
      if (uniqVisibility[0] === 1) {
        setVisibility(true)
      }
    }
  }, [openPublishDialog])

  let labelVisibility = 'Hidden Zoom Links'

  useEffect(() => {
    if (visibility) {
      labelVisibility = 'Show Zoom Links'
    }
  }, [visibility])

  // trigger this onSuccess course details response
  useEffect(() => {
    if (courseId !== 0 || courseId !== '') {
      console.log('course details')
      console.log(courseDetails)

      if (courseDetails.hasOwnProperty('course_code')) {
        setTitle(courseDetails.course_code)
        setSubTitle(`Course ID: ${courseDetails.id}`)
      }
    }
  }, [courseDetails])

  // load one time schedulers list
  useEffect(() => {
    getMySchedulers().then(function (schedulers) {
      if (schedulers?.data) {
        onResponseSchedulers(schedulers.data.data.schedulers)
      }
    })
  }, [])

  // trigger when dialog close
  // clear states
  const handleClose = () => {
    updateCourseId(0)
    updateZoomEvents({ data: [], method: 'CLEAR' })
    onUpdateSelected([])
    setFullPageModel(false)
    setOpenPublishDialog(false)
    setZoomCoHost([])
    setZoomCoHostError(null)
    setZoomCoHostValue('')
    setZoomHost('')
    setErrors('')
    setScheduler(schedulersConfig.admin)
    // setOwner(false);
    setVisibility(false)
    setRefreshTable(false)
  }

  // trigger when dialog close
  // clear states
  const handleDoneCancel = () => {
    setOpenPublishDialog(false)
    onUpdateSelected([])
    setPublishProgress(1)
    setZoomCoHost([])
    setZoomCoHostValue('')
    setZoomCoHostError(null)

    setZoomHost('')
    setErrors('')
    setScheduler(schedulersConfig.admin)
    // setOwner(false);
    setVisibility(false)
    setRefreshTable(false)
  }

  const handleZoomHostChange = (event) => {
    setZoomHost(event.target.value)
  }

  const handleZoomCoHostChange = (event) => {
    setZoomCoHost(event.target.value)
  }

  const handleRemoveSelected = (event) => {}

  const handleVisibilityChange = (event) => {
    if (scheduler !== null) {
      if (
        scheduler.email === schedulersConfig.admin.email ||
        scheduler === ''
      ) {
        setErrors('Please select owner, before making link visible')
        return false
      } else {
        setErrors([])
      }
    }

    setVisibility(event.target.checked)
  }

  const handleOwnerChange = (event) => {
    if (event.target.checked === false) {
      setVisibility(false)
      setScheduler(schedulersConfig.admin)
    }

    setOwner(event.target.checked)
  }

  //onMerge this function will be called
  const handleMerge = async () => {
    setRefreshTable(false)

    if (mergeParentEvent === null) {
      setMergeErrors('Please select a parent event.')
      return false
    }

    let payload = {
      parentEvent: mergeParentEvent,
      childEvents: selectedEventIds
    }

    setMergeProgress(2)

    let mergeEvents = await updateMergeEvents(payload)

    setMergeProgress(3)
    setRefreshTable(true)
  }

  const handleMergeDoneCancel = () => {
    setOpenMergeDialog(false)
    onUpdateSelected([])
    setMergeErrors([])
    setMergeProgress(1)
    setRefreshTable(false)
  }

  /**
   * This function handle the action of update zoom link on zoom creation
   */
  const handlePublish = async () => {
    if (scheduler === null) {
      setErrors('Zoom owner cannot be empty.')
      return false
    } else {
      setErrors([])
    }

    if (
      scheduler.email === schedulersConfig.admin.email &&
      visibility === true
    ) {
      setErrors('Please change Zoom Owner.')
      return false
    } else {
      setErrors([])
    }

    // if (scheduler !== "") {
    //   setErrors('Please select owner');
    //   return false;
    // } else {
    //   setErrors([])
    // }

    setPublishProgress(2)

    let eventData = selectedEventIds.data
    console.log('DEBUG EVENT DATA',eventData);
    console.log('DEBUG SELECTED EVENT ID',selectedEventIds);
    let hasError = false // Flag to track errors during loop execution
    for (let i = 0; i < eventData.length; i++) {
      let zoomCreated = false
      let reservation_id = eventData[i].time_edit_reservation_id
      let zoomLink = eventData[i].zoom_link

      if (zoomLink) {
        zoomCreated = true
      }

      let zoomCoHostComma = zoomCoHost.join(',')

      let payload = {
        reservation_id: reservation_id,
        host: scheduler.email,
        coHost: zoomCoHostComma,
        visibility: visibility,
        zoom_meeting_created: zoomCreated,
        calendar_event: eventData[i]
      }

      try {
        let res = await updateZoomOwner(payload)
      }catch(e) {
        console.error('Error occurred during loop execution:', error)
        hasError = true
      }

    }
    if (!hasError) {
      setPublishProgress(3)
      setZoomCoHost([])
      setZoomCoHostValue('')
      setZoomCoHostError(null)
      //remote refresh
      // tableRef.current.onQueryChange();
      //manual refresh
      console.log('courseId', courseId)
      setRefreshTable(true)
    }
  }

  const handleClosePublishDialog = () => {
    setOpenPublishDialog(false)
    setZoomCoHost([])
    setZoomCoHostValue('')
    setZoomCoHostError(null)

    setZoomHost('')
    setErrors('')
  }

  const handleCloseMergeDialog = () => {
    setOpenMergeDialog(false)
  }

  /// CO HOST TEXT BOX

  const handleKeyDown = (evt) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault()

      var value = zoomCoHostValue

      if (value && isValid(zoomCoHostValue)) {
        setZoomCoHost([...zoomCoHost, value])
        setZoomCoHostValue('')
      }
    }
  }

  const handleChange = (event) => {
    // this.setState({
    //   value: evt.target.value,
    //   error: null
    // });;
    setZoomCoHostValue(event.target.value)
    //setZoomCoHost(event.target.value);
    setZoomCoHostError(null)
  }

  const handleBlur = (evt) => {
    var emails = evt.target.value.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g)

    if (emails) {
      var toBeAdded = emails?.filter((email) => !isInList(email))
      setZoomCoHost([...zoomCoHost, ...toBeAdded])
      setZoomCoHostValue('')
    }
  }

  const handleDelete = (item) => {
    let items = zoomCoHost

    items = items?.filter((i) => i !== item)

    setZoomCoHost(items)
    setZoomCoHostValue('')
  }

  const handlePaste = (evt) => {
    evt.preventDefault()

    var paste = evt.clipboardData.getData('text')
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g)

    if (emails) {
      var toBeAdded = emails?.filter((email) => !isInList(email))
      setZoomCoHost([...zoomCoHost, ...toBeAdded])
      setZoomCoHostValue('')
    }
  }

  const isValid = (email) => {
    let error = null

    if (isInList(email)) {
      error = `${email} has already been added.`
    }

    if (!isEmail(email)) {
      error = `${email} is not a valid email address.`
    }

    if (error) {
      setZoomCoHostError(error)

      return false
    }

    return true
  }

  const isInList = (email) => {
    let items = zoomCoHost

    return items.includes(email)
  }

  const isEmail = (email) => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email)
  }

  let selectedEventIdArr = selectedEventIds.data.map((item) => item.id)

  let dropdownParentList = zoomEvents?.data?.filter(
    (data) =>
      data.zoom_parent_id === null &&
      data.hasOwnProperty('zoom_link') === true &&
      data.zoom_link !== null &&
      !selectedEventIdArr.includes(data.id)
  )

  return (
    <div>
      <Dialog
        key='ddd'
        fullScreen
        open={fullPageModel}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              {title}
            </Typography>

            <Typography variant='span' className={classes.title}>
              {subTitle}
            </Typography>

            <Button
              onClick={() => {
                setOpenMergeDialog(true)
              }}
              startIcon={<DynamicFeedIcon />}
              style={{ backgroundColor: '#ffdb2c', marginRight: 10 }}
            >
              Merge Zoom Link
            </Button>

            <Button
              onClick={() => {
                setOpenPublishDialog(true)
              }}
              startIcon={<SettingsIcon />}
              style={{ backgroundColor: '#ffdb2c' }}
            >
              Manage Zoom Links
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent style={{ backgroundColor: '#4caf500d' }} dividers={true}>
          <div className={classes.root}>
            <div className={classes.root}>
              <br />
              <br />

              <Grid container justify='center' alignItems='center' spacing={3}>
                <Grid item xs={12}>
                  <CourseTable
                    refreshTable={refreshTable}
                    setRefreshTable={setRefreshTable}
                    tableRef={tableRef}
                  ></CourseTable>
                </Grid>
              </Grid>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth
        disableBackdropClick
        maxWidth={'md'}
        open={openPublishDialog}
        onClose={handleClosePublishDialog}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Publish Zoom Links '}

          <Badge
            style={{ float: 'right' }}
            badgeContent={selectedEventIds.data.length}
            color='primary'
          >
            {' '}
            Event{' '}
          </Badge>
        </DialogTitle>

        <Divider />

        <DialogContent>
          {errors.length !== 0 ? (
            <Alert severity='error'>{errors}</Alert>
          ) : null}

          {selectedEventIds.data.length === 0 && publishProgress === 1 ? (
            <Alert severity='error'>
              Select a zoom event(s) before you click Publish.
            </Alert>
          ) : null}

          {publishProgress === 3 ? (
            <Alert severity='success'>Successfully event(s) updated. </Alert>
          ) : null}

          {publishProgress === 2 || publishProgress === 3 ? (
            <div className={classes.root}>
              {publishProgress === 2 ? (
                <div>
                  Please wait..
                  <LinearProgress />
                </div>
              ) : null}
              <br /> <br />
              Main Host: {scheduler.email}
              <br /> <br />
              Co Host: {zoomCoHost.join(',')}
              <br /> <br />
              {selectedEventIds.data.map((item) => (
                <Chip label={item.title} className={classes.chip} />
              ))}
            </div>
          ) : null}

          {selectedEventIds.data.length !== 0 && publishProgress === 1 ? (
            <div>
              <br />
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={owner}
                    onChange={handleOwnerChange}
                    name='checkOwner'
                  />
                }
                label='Owner'
              />
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={visibility}
                    onChange={handleVisibilityChange}
                    name='checkVisibility'
                  />
                }
                label='Visibility'
              />
              <br /> <br />
              <Autocomplete
                fullWidth
                value={scheduler}
                disabled={!owner}
                onChange={(event, newValue) => {
                  setScheduler(newValue)
                }}
                id='controllable-states-demo'
                options={schedulersList}
                getOptionLabel={(schedulersList) =>
                  schedulersList.hasOwnProperty('name') === true
                    ? schedulersList.name
                    : schedulersList.email
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Zoom Owner'
                    variant='outlined'
                  />
                )}
              />
              {/* <FormControl fullWidth  >


                <br />

                <TextField
                  id="outlined-name"
                  label="Alternative Hosts"
                  variant="outlined"
                  name='co_host'
                  onChange={handleZoomCoHostChange}
                />
              </FormControl> */}
              <br />
              <Tooltip
                placement='top'
                title='Type email address and Press Enter'
                arrow
              >
                <TextField
                  fullWidth
                  error={zoomCoHostError}
                  id='outlined-multiline-static'
                  label=' Zoom alternative hosts.'
                  multiline
                  rows='1'
                  variant='outlined'
                  value={zoomCoHostValue}
                  onKeyDown={handleKeyDown}
                  onChange={handleChange}
                  onPaste={handlePaste}
                  onBlur={handleBlur}
                  helperText='Type email address and Press Enter'
                />
              </Tooltip>
              <br />
              <br />
              {zoomCoHostError && <p className='error'>{zoomCoHostError}</p>}
              {zoomCoHost.map((item) =>
                item.length ? (
                  <Chip
                    label={item}
                    key={item}
                    onDelete={() => handleDelete(item)}
                    style={{ margin: '4px' }}
                  />
                ) : (
                  ''
                )
              )}
              <br /> <br />
              <MaterialTable
                title='Selected Events'
                data={selectedEventIds.data}
                columns={[
                  {
                    field: 'id',
                    title: 'Event ID',
                    render: (rowData) => {
                      let title = rowData.id

                      let count = selectedEventIds?.data?.filter(
                        (item) =>
                          item.zoom_parent_id != null &&
                          rowData.id === item.zoom_parent_id
                      )

                      let countRender =
                        count.length !== 0 ? (
                          <Alert severity='info'>{` This event has ${count.length} merged events `}</Alert>
                        ) : null

                      return (
                        <div>
                          {' '}
                          {title} <br />
                          <br /> {countRender}{' '}
                        </div>
                      )
                    }
                  },

                  {
                    field: 'title',
                    title: 'Title'
                  }
                ]}
                parentChildData={(row, rows) =>
                  rows.find((a) => a.id === row.zoom_parent_id)
                }
                options={{
                  selection: false,
                  showTextRowsSelected: false
                }}
              />
            </div>
          ) : null}
        </DialogContent>

        <Divider />
        <DialogActions>
          {publishProgress === 3 ? (
            <Button onClick={handleDoneCancel} color='primary' autoFocus>
              Done
            </Button>
          ) : null}

          {publishProgress === 1 ? (
            <Button onClick={handleDoneCancel} color='primary' autoFocus>
              Cancel
            </Button>
          ) : null}

          {publishProgress === 1 && selectedEventIds.data.length !== 0 ? (
            <Button onClick={handlePublish} color='primary' autoFocus>
              Save
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        disableBackdropClick
        open={openMergeDialog}
        onClose={handleCloseMergeDialog}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Merge Zoom Links '}

          <Badge
            style={{ float: 'right' }}
            badgeContent={selectedEventIds.data.length}
            color='primary'
          >
            {' '}
            Event{' '}
          </Badge>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <div>
            {mergeProgress === 2 ? (
              <div>
                Please wait..
                <LinearProgress />
              </div>
            ) : null}

            {mergeErrors.length !== 0 ? (
              <Alert severity='error'>{mergeErrors}</Alert>
            ) : null}

            {mergeProgress === 3 ? (
              <Alert severity='success'>Successfully event(s) updated. </Alert>
            ) : null}
            <br />

            <Typography
              style={{
                background: 'aliceblue',
                fontWeight: 'bold'
              }}
            >
              Parent event
            </Typography>
            <br />

            <Autocomplete
              fullWidth
              id='combo-box-demo'
              options={dropdownParentList}
              getOptionLabel={(option) => option.title}
              onChange={(event, newValue) => {
                setMergeParentEvent(newValue)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Select Main event'
                  variant='outlined'
                />
              )}
            />

            <br />

            <Typography
              style={{
                background: 'aliceblue',
                fontWeight: 'bold'
              }}
            >
              Child events
            </Typography>

            {selectedEventIds.data.map((item) => (
              <>
                <Divider />
                <Chip
                  fullWidth
                  label={item.title}
                  className={classes.chipMerge}
                  onDelete={handleRemoveSelected}
                />
              </>
            ))}
          </div>
        </DialogContent>

        <Divider />
        <DialogActions>
          {mergeProgress === 3 ? (
            <Button onClick={handleMergeDoneCancel} color='primary' autoFocus>
              Done
            </Button>
          ) : null}

          {mergeProgress === 1 ? (
            <Button onClick={handleMergeDoneCancel} color='primary' autoFocus>
              Cancel
            </Button>
          ) : null}

          {mergeProgress === 1 && selectedEventIds.data.length !== 0 ? (
            <Button onClick={handleMerge} color='primary' autoFocus>
              Save
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    data: state.ZoomMeetings,
    selectedEventIds: state.ZoomMeetings.selectedEventIds,
    zoomEvents: state.ZoomMeetings.events,
    schedulersList: state.ZoomMeetings.schedulers.data,
    courseDetails: state.ZoomMeetings.courseDetails,
    zoomEvents: state.ZoomMeetings.events
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateCourseId: (courseId) => {
    dispatch(updateZoomCourseId(courseId))
  },

  updateZoomEvents: (data) => {
    dispatch(loadZoomEventsData(data))
  },

  onUpdateSelected: (data) => {
    dispatch(updateSelectedZoomEvents(data))
  },

  onResponseSchedulers: (data) => {
    dispatch(updateZoomSchedulers(data))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(FullScreenDialog)
